// extracted by mini-css-extract-plugin
export default {"aboutTitle":"styles_aboutTitle__Cndxg","payInFont":"styles_payInFont__bTAUt","cancelBtn":"styles_cancelBtn__sL6of"};